/*
 *   File : funds.js
 *   Author URI : www.evoqins.com
 *   Description : To show the available funds in Master Trust platform.
 *   Integrations : NA
 *   Version : v1.0
 *   Created : 14-09-2023
 */
/* import packages */
import { useEffect, useState } from "react";

/* import components */
import { DataTableContainer } from "../FormElements";
import Icon from "../Icon/icon";

/* import styles */
import Colors from '../../Styles/color.module.scss';


const FundTable = (props) => {
    const [showArrow, setShowArrow] = useState(0);
    const [fundGoals, setFundGoals] = useState(props.data);

    useEffect(() => {
        setFundGoals(props.data);
    }, [props.data])

    const FUNDS_COLUMN = [
        {
            id: 1,
            name: 'Funds',
            selector: row => row['name'],
            sortable: true,
            left: true,
            maxWidth: "700px",
            cell: row =>
                <div className="d-flex align-items-center gap-12px e-fund-name"
                    onClick={() => _handleCardClick(row)}>
                    <div className="p-2 border-radius-8px border-all border-bright-gray w-unset">
                        <img draggable={false} src={row['image']} alt={row['name']}
                            width={36}
                            height={36} />
                    </div>
                    <div className="d-flex flex-column gap-12px">
                        <span className="color-black e-poppins-medium e-font-16 line-height-16px mb-0 bg-white">{row['name']}</span>
                        <span className="border-radius-16px border-all border-bright-gray py-1 padding-12px-lr color-black e-poppins-medium e-font-10 line-height-18px w-fit-content">
                            {row['type']}
                        </span>
                    </div>

                </div>
        },
        {
            id: 2,
            name: "CAGR (3Y)",
            width: "80px",
            selector: row => row['cagr'],
            sortable: true,
            left: true,
            style: {
                color: Colors.black,
                fontFamily: "Poppins-SemiBold",
                fontSize: "16px",
                lineHeight: "18px",
            },
            cell: row =>
                <p className="color-dark-spring-green e-poppins-semi-bold e-font-14 line-height-20px mb-0 margin-22px-right"
                    onClick={() => _handleCardClick(row)}>
                    {row['cagr']}%
                </p>
        },
        {
            id: 3,
            name: 'AUM',
            selector: row => row['aum'],
            sortable: true,
            left: true,
            width: "70px",
            cell: row =>
                <p className="color-black e-poppins-semi-bold e-font-14 line-height-20px mb-0"
                    onClick={() => _handleCardClick(row)}>
                    {row['aum']}
                </p>
        },
        {
            id: 4,
            name: 'Risk',
            selector: row => row['risk'],
            sortable: true,
            left: true,
            maxWidth: "80px",
            cell: row =>
                <div className="d-flex w-100 justify-content-center "
                    onClick={() => _handleCardClick(row)}>
                    <img draggable={false} src={require("../../Assets/Images/Others/high-risk.png")}
                        alt="High risk"
                        width={42}
                        height={40}
                        className="object-fit-contain" />
                </div>

        },
        {
            id: 5,
            name: 'Rating',
            selector: row => row['rank'],
            sortable: true,
            left: true,
            width: "80px",
            style: {
                color: Colors.black,
                fontSize: "14px",
                lineHeight: " 20px"
            },
            cell: row =>
                <div className="d-flex align-items-center justify-content-center "
                    onClick={() => _handleCardClick(row)}>
                    <p className="mb-0 e-poppins-semi-bold">{row['rank']}</p>
                    <img draggable={false} src={require("../../Assets/Images/Others/star.png")}
                        alt="Rating"
                        width={16}
                        height={16} />
                </div>

        },

        {
            id: 6,
            name: '',
            sortable: false,
            left: true,
            width: "24px",
            cell: row => <div className={`e-fund-order-hover text-start ${showArrow === row.id ? 'show' : ''}`}>
                <Icon icon="arrow-right1"
                    size={24}
                    color={Colors.black} />
            </div>

        }

    ];

    const _handleRowHover = (row) => {
        setShowArrow(row.id)
    }

    const _handleRowRemoveHover = () => {
        setShowArrow(0);
    }

    const _handleCardClick = (row) => {
        props.onSelect(row);
    }



    const TABLE_STYLE = {
        table: {
            style: {
                padding: "0 16px 16px 16px",
                background: Colors.white,
            },
        },
        tableBody: {
            style: {
                margin: '0px',
                marginTop: "0px !important"
            }
        },
        headRow: {
            style: {
                display: 'none',
                background: 'transparent',
                borderRadius: "16px 16px 0px 0px",
                border: "0",
                borderBottom: `1px solid ${Colors.bright_gray} !important`,
                fontSize: "14px",
                fontFamily: "Poppins-Medium",
                lineHeight: "24px",
                color: Colors.black
            }
        },
        rows: {
            style: {
                margin: "0",
                background: "transparent",
                border: `1px solid ${Colors.bright_gray} !important`,
                borderRadius: "16px",
                marginTop: "14px",
                fontSize: "16px",
                fontFamily: "Poppins-Regular",
                lineHeight: "24px",
                cursor: "pointer",
                color: Colors.black,
                '&:hover': {
                    boxShadow: '0px 12px 16px 0px rgba(50, 50, 71, 0.08)',
                },
            },
        },
        cells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:last-child': {
                    padding: "0px",
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        headCells: {
            style: {
                '&:not(:last-child)': {
                    paddingLeft: '0px',
                    paddingRight: '0px',
                    display: 'flex',
                },
                '&:last-child': {
                    padding: "0px",
                },
                '&:first-child': {
                    padding: "24px 0px 24px 24px",
                }
            },
        },
        pagination: {
            style: {
                borderTop: `none `,
                color: Colors.outer_space,
                fontSize: '16px',
                fontFamily: "Poppins-Regular",
            },
        }
    }

    return (

        <DataTableContainer columns={FUNDS_COLUMN}
            data={fundGoals}
            pagination={false}
            customStyles={TABLE_STYLE}
            onRowMouseEnter={_handleRowHover}
            onRowMouseLeave={_handleRowRemoveHover}
            rowClick={(row) => _handleCardClick(row)} />

    )
}

export default FundTable